import { Component, OnInit } from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { ALERTS, formatDate, FormBuilder, FormGroup, NgbModal, Validators } from 'src/app/common';
import { CONFIG_TYPE } from 'src/app/common/constants';
import { IConfigNotification } from 'src/app/models/i-config-notification';
import { IUdfFormato, UdfFormats } from 'src/app/models/i-udf-formato';
import { AlertService, BlockUiHandlerService } from 'src/app/services';
import { ConfigNotificationService } from 'src/app/services/config-notification.service';
import * as ts from 'typescript';

@Component({
  selector: 'app-config-notificaciones',
  templateUrl: './config-notificaciones.component.html',
  styleUrls: ['./config-notificaciones.component.css']
})
export class ConfigNotificacionesComponent implements OnInit {
  configuracion: any;
  configuracionForm: FormGroup;
  file: any;
  mails: string[];
  copymails: string[];
  mail: string;
  configTYPE: string;
  CrystalReportName: string;
  CONFIG_TYPE: any;
  modalFormato: any;
  closeResult: string;
  udfFormato: IUdfFormato[];//obtiene info de udf segun su categoría 
  udfFormatoValues: UdfFormats[];//Formatos configurados para enviar
  udfFormatData: UdfFormats[];// Obtiene formatos configurados en bd app
  FormatoSelected = false;
  HardCodedReportFiles: File[];

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private configNotificationService: ConfigNotificationService,
    private blockUiService: BlockUiHandlerService,
    private modalService: NgbModal,) {
    this.CONFIG_TYPE = CONFIG_TYPE
  }

  ngOnInit(): void {
    this.InitVariables();
    this.LoadData();

  }

  InitVariables(): void {
    this.HardCodedReportFiles = [];
    this.ResetConfiguracionForm();
    this.udfFormato = [];
    this.udfFormatoValues = [];
    this.GetUdfFormatApp();



  }

  LoadData(): void {
    this.SwitchTab(CONFIG_TYPE.PurchaseRequest)
  }

  SwitchTab(Type: string) {
    this.configTYPE = Type;

    if (this.configTYPE == 'OPRQ') {
      //(<HTMLInputElement>document.getElementById('file')).value = '';

    } else {
      this.GetUdfFormatosModal(this.configTYPE, 'Formatos');

    }

    this.configuracionForm.controls['Type'].setValue(Type);
    this.blockUiService.Start(1, `Cargando configuraciones, espere por favor`);
    this.configNotificationService.GetByType(Type).subscribe((next) => {
      this.blockUiService.Stop();

      if (next.Result) {
        let tempEmails = next.Config.Emails;
        let tempCopyEmails = next.Config.CopyEmails;
        this.mails = [];
        this.copymails = [];
        if (tempEmails) {
          tempEmails.split(',').forEach((email) => { this.mails.push(email) })
        }
        if (tempCopyEmails) {
          tempCopyEmails.split(',').forEach((email) => { this.copymails.push(email) })
        }
        next.Config.Emails = '';
        next.Config.CopyEmails = '';

        this.CrystalReportName = next.Config.CrystalReportName;
        this.configuracionForm.patchValue({
          ...next.Config
        });

      } else {
        this.blockUiService.Stop();
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });



  }

  ResetConfiguracionForm(): void {
    // Formatea la fecha por defecto
    let DateNow = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.configuracionForm = this.formBuilder.group({
      Id: [-1],
      Type: [CONFIG_TYPE.PurchaseOrder],
      Email: ['1',],
      TimeRep: ['60', Validators.required],
      Emails: ['', [Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]],
      CopyEmails: ['', [Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]],
      Subject: ['', Validators.required],
      Body: ['', Validators.required],
      IsActive: [true, Validators.required],
      CrystalReportName: ['']

    });
    this.mails = [];
    this.copymails = [];
  }

  AddEmail(event: any): void {
    if (event.key == 'Enter' && this.configuracionForm.controls['Emails'].value) {
      if (!this.configuracionForm.controls['Emails'].invalid) {
        if (!this.mails.includes(this.configuracionForm.controls['Emails'].value)) {
          this.mails.push(this.configuracionForm.controls['Emails'].value);
        } else {
          this.alertService.ShowSmallCornerAlert(`El correo ya está agregado`, ALERTS.info);
        }
        this.configuracionForm.controls['Emails'].setValue('');
      }
    }
  }

  AddCopyEmail(event: any): void {
    if (this.configuracionForm.controls['CopyEmails'].value && !this.configuracionForm.controls['CopyEmails'].invalid) {
      if (!this.copymails.includes(this.configuracionForm.controls['CopyEmails'].value)) {
        this.copymails.push(this.configuracionForm.controls['CopyEmails'].value);
      } else {
        this.alertService.ShowSmallCornerAlert(`El correo ya está agregado`, ALERTS.info);
      }
      this.configuracionForm.controls['CopyEmails'].setValue('');
    }
  }

  //Agrega el mail en caso de salir del input
  AddEmailFocusOut(event: any): void {
    if (!this.configuracionForm.controls['Emails'].invalid && this.configuracionForm.controls['Emails'].value) {
      if (!this.mails.includes(this.configuracionForm.controls['Emails'].value)) {
        this.mails.push(this.configuracionForm.controls['Emails'].value);
      } else {
        this.alertService.ShowSmallCornerAlert(`El correo ya está agregado`, ALERTS.info);
      }
      this.configuracionForm.controls['Emails'].setValue('');
    }
  }

  AddCopyEmailFocusOut(event: any): void {
    if (!this.configuracionForm.controls['CopyEmails'].invalid && this.configuracionForm.controls['CopyEmails'].value) {
      if (!this.copymails.includes(this.configuracionForm.controls['CopyEmails'].value)) {
        this.copymails.push(this.configuracionForm.controls['CopyEmails'].value);
      } else {
        this.alertService.ShowSmallCornerAlert(`El correo ya está agregado`, ALERTS.info);
      }
      this.configuracionForm.controls['CopyEmails'].setValue('');
    }
  }

  DeleteMail(_index: number): void {
    this.mails.splice(_index, 1);
  }

  DeleteCopyMail(_index: number): void {
    this.copymails.splice(_index, 1);
  }

  FileBrowseHandler(event, valueudf: string): void {

    if (event.srcElement.files) {
      let FileExtention: string = event.srcElement.files[0].name.split('.').pop();
      if (FileExtention.toUpperCase() === 'RPT') {
        if (this.configTYPE == 'OPOR') {
          this.udfFormatoValues.forEach((inv, index) => {

            if (inv.IdUdf == valueudf) {
              this.file = event.srcElement.files;
              inv.ReportName = this.file[0].name;
              this.HardCodedReportFiles[index] = event.srcElement.files[0];
              //this.CrystalReportName = this.file[0].name;
            }
          });
        } else {
          this.file = event.srcElement.files;
          //inv.ReportName = this.file[0].name;;
          this.CrystalReportName = this.file[0].name;
        }

      } else {
        this.alertService.ShowSmallCornerAlert(`El tipo de archivo debe ser rpt`, ALERTS.error);
      }
    }
    // console.log(valueudf);
    // if(event.srcElement.files){
    //   let FileExtention: string = event.srcElement.files[0].name.split('.').pop();
    //   if(FileExtention.toUpperCase() === 'RPT'){
    //     this.file = event.srcElement.files;
    //     this.CrystalReportName = this.file[0].name;
    //   } else {
    //     this.alertService.ShowSmallCornerAlert(`El tipo de archivo debe ser rpt`, ALERTS.error);
    //   }
    // }
  }

  SaveConfiguration() {
    let Config = this.configuracionForm.value as IConfigNotification;
    let frmdata = new FormData();
    //Verificación de correos
    if (this.mails.length) {
      Config.Emails = this.mails.join(',');
    } else {
      this.alertService.ShowSmallCornerAlert(`Se espera al menos un correo`, ALERTS.info);
      return null;
    }
    if (this.copymails.length) {
      Config.CopyEmails = this.copymails.join(',');
    }
    if (!this.configuracionForm.valid) {
      this.alertService.ShowSmallCornerAlert(`Todos los campos son requeridos`, ALERTS.info);
      return null;
    } else {
      frmdata.append('configNotification', JSON.stringify(Config));

      if (this.file != null) {
        frmdata.append('file', this.file[0]);
      }
      this.StoreConfiguracion(frmdata, Config.Id);
    }
  }

  fn_downloadFile(name: string) {
    // if(name != null){   
    this.configNotificationService.downloadReportFile(name, this.configTYPE).subscribe(resp => {
      if (resp.Result) {
        this.downloadFile(resp.file, name.split('.')[0], 'application/octet-stream', 'rpt');
      } else {
        this.alertService.ShowSmallCornerAlert(`Error al descargar archivo.${resp.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
    // }else{
    //   this.alertService.ShowSmallCornerAlert(`No se ha configurado reporte para la descripción`, ALERTS.info);
    // }
  }

  private downloadFile(
    base64File: string,
    fileName: string,
    blobType: string,
    fileExtension: string
  ) {
    let report = new Blob([this.stringToArrayBuffer(atob(base64File))], {
      type: blobType,
    });

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(report);
    link.download = `${fileName}.${fileExtension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private stringToArrayBuffer(toConvert: string) {
    let buf = new ArrayBuffer(toConvert.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i != toConvert.length; ++i)
      view[i] = toConvert.charCodeAt(i) & 0xff;
    return buf;
  }

  UpdateConfiguracion(ConfigNotification: IConfigNotification) {
    this.blockUiService.Start(1, `Actualizando configuraciones, espere por favor`);
    this.configNotificationService.Put(ConfigNotification).subscribe((next) => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.alertService.ShowSmallCornerAlert(`Configuración actualizada`, ALERTS.success);
      } else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  StoreConfiguracion(pData: FormData, id: number) {
    let msj = id <= 0 ? "Creando configuracion, espere por favor" : "Actualizando configuracion, espere por favor";

    this.blockUiService.Start(1, msj);
    this.configNotificationService.Store(pData).subscribe((next) => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.SwitchTab(this.configTYPE);
        //  (<HTMLInputElement>document.getElementById('file')).value = '';
        this.alertService.ShowSmallCornerAlert(id <= 0 ? "Configuración creada" : "Configuración actualizada", ALERTS.success);
      } else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }
  //Modal con listado para cargar y descargar formatos de impresón en OPOR
  openModal(content) {
    this.GetUdfFormatApp();
    this.GetUdfFormatosModal(this.configTYPE, 'Formatos');

    this.modalFormato = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', windowClass: 'Modal-sm' });
    this.modalFormato.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
    });
  }
  close() {
    this.modalFormato.close();
  }
  //Guardar formato de impresión en bd local y reportes en el path
  SaveFormato() {
    let frmdata = new FormData();
    frmdata.append('UdfFormats', JSON.stringify(this.udfFormatoValues));
    this.HardCodedReportFiles.forEach((Report, index) => {
      frmdata.append('file_' + index, Report);     
    })
    this.configNotificationService.SaveUdfFormat(frmdata, this.alertService, this.modalService);

    //this.blockUiService.Start(1, `Actualizando configuración, espere por favor`);
    //  // this.udfFormatoValues = this.udfFormatoValues.filter(y => y.ReportName != null);
    //   this.configNotificationService.SaveUdfFormat(this.udfFormatoValues).subscribe(next => {
    //     this.blockUiService.Stop();
    //     if (next.Result) {
    //       this.alertService.ShowSmallCornerAlert(`Formatos de impresión actualizados`, ALERTS.success);

    //      this.close();
    //     }
    //   }, error => {

    //     this.blockUiService.Stop();
    //   });
  }

  GetUdfFormatosModal(category: string, nameudf: string): void {
    this.configNotificationService.GetUdfFormatos(category, nameudf).subscribe(next => {
      if (next.Result) {
        this.udfFormato = next.Udfs;
        this.udfFormato.forEach(x => x.MappedValues = (JSON.parse(x.Values) as UdfFormats[]));
        this.udfFormatoValues = this.udfFormato[0].MappedValues;

        this.udfFormatData.forEach(x => {
          this.HardCodedReportFiles.push(null);
          this.udfFormatoValues.forEach(y => {
            if (x.IdUdf == y.IdUdf) {
              y.ReportName = x.ReportName;
            }
          });
        });

      }
    }, error => {
      console.log(error);
    });
  }

  GetUdfFormatApp() {
    this.configNotificationService.GetUdfFormat().subscribe(next => {
      if (next.Result) {
        this.udfFormatData = next.UdfFormats;
      }
      else {
        this.udfFormatData = [];
      }
    }, error => {
      console.log(error);
    });
  }
}
